import { createContext } from 'react';

import config from '../../../config';

export const FeatureFlagPossibleState = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;

type FeatureFlagState = keyof typeof FeatureFlagPossibleState;

export const featureFlagsMap = {
  FF_ES_TARGETING: config.FF_ES_TARGETING,
} as const;

type FeatureFlagKey = keyof typeof featureFlagsMap;

export type FeatureFlags = Record<FeatureFlagKey, FeatureFlagState | undefined>;

export const FeatureFlagsContext = createContext<FeatureFlags | undefined>(undefined);
